import { render, staticRenderFns } from "./v80o1020Pop.vue?vue&type=template&id=23e1c72c&scoped=true"
import script from "./v80o1020Pop.vue?vue&type=script&lang=js"
export * from "./v80o1020Pop.vue?vue&type=script&lang=js"
import style0 from "./v80o1020Pop.vue?vue&type=style&index=0&id=23e1c72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1c72c",
  null
  
)

export default component.exports